import React from 'react'
import { Column, Grid } from '@tumelo/designsystem'
import { OuterContainerLayout } from './OuterContainerLayout'

interface Props {
  children: React.ReactNode
  withMaxWidth: boolean
}
export const PageWrapper: React.FC<Props> = ({ children, withMaxWidth }) => {
  return (
    <main>
      <OuterContainerLayout $withMaxWidth={withMaxWidth}>
        <Grid>
          <Column xs={12} sm={12} md={12} lg={12}>
            {children}
          </Column>
        </Grid>
      </OuterContainerLayout>
    </main>
  )
}
